var Marionette = require('backbone.marionette');

var SettingsList = Marionette.View.extend({
    template: require('../../templates/settings/settings.html'),

    initialize: function (options) {
        window.document.title = "Settings";
    }

});


module.exports = SettingsList;


//////////////////
// WEBPACK FOOTER
// ./app/views/settings/settings.js
// module id = 424
// module chunks = 0